// extracted by mini-css-extract-plugin
module.exports = {"amwzuv0":"amwzuv0"};